// noinspection JSIgnoredPromiseFromCall

import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { patchDriver } from '../../services/DriversService';
import { Driver, PatchDriverRequest } from '../../types/Drivers';

type Result = UseMutationResult<Driver, Error, PatchDriverRequest>;

function usePatchDriver(successCb: () => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(patchDriver, {
    onSuccess: () => {
      successCb();
      queryClient.invalidateQueries({ queryKey: ['driver'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default usePatchDriver;
